var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLine = function SvgLine(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 4",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7245 3.32926L0.694489 3.32926L0.345703 0.349609L11.3757 0.349609L11.7245 3.32926Z",
    fill: "#EFBB54"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLine);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDEyIDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuNzI0NSAzLjMyOTI2TDAuNjk0NDg5IDMuMzI5MjZMMC4zNDU3MDMgMC4zNDk2MDlMMTEuMzc1NyAwLjM0OTYwOUwxMS43MjQ1IDMuMzI5MjZaIiBmaWxsPSIjRUZCQjU0Ii8+Cjwvc3ZnPgo=";